import React from 'react';
import { Route, Switch } from 'wouter';

import MainLayout from './layouts/Main';
import HomePage from './pages/Home';

interface RoutesProps {
    micromag?: Record<string, any> | null;
    disabled?: boolean;
}

function Routes({ micromag = null, disabled = false }: RoutesProps) {
    return (
        <MainLayout>
            <Switch>
                <Route>
                    <HomePage micromag={micromag} disabled={disabled} />
                </Route>
            </Switch>
        </MainLayout>
    );
}

export default Routes;
